// DS: ???
import React from 'react';
import classnames from 'classnames';
import ChatIcon from '@wix/da-ds/pkg/Icons/24x24/Chat';
import { URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { useVerification } from '../../../VerificationPopup/withVerification';
import SiteHeaderIconButton from '../_partials/SiteHeaderIconButton';
import style from '../SiteHeaderMobile.scss';
var ChatButton = function (_a) {
    var isLegacyHeader = _a.isLegacyHeader, count = _a.count, onOpenModal = _a.onOpenModal, className = _a.className;
    var restrictToVerified = useVerification().restrictToVerified;
    var onClick = restrictToVerified('chat', function () { return onOpenModal(); });
    return (React.createElement("div", { className: classnames(style['chat-icon-container'], className) },
        React.createElement(SiteHeaderIconButton, { icon: ChatIcon, href: isLegacyHeader ? URLS.CHAT_HOME : undefined, onClick: !isLegacyHeader ? onClick : undefined, biData: BiData({
                evid: 700,
                link_name: 'chat',
            }), count: count })));
};
ChatButton.displayName = 'ChatButton';
export default ChatButton;
//# sourceMappingURL=ChatButton.js.map